// tslint:disable:no-increment-decrement

// TODO Use existing functions from 'kommon' package

const UNITS = ['B', 'KB', 'MB', 'GB', 'TB'];

export interface HumanSize {
  size: string;
  unit: string;
}

export interface HumanSizeOf {
  used: HumanSize;
  total?: HumanSize;
}

function fixPoint(num: number): string {
  let fixed = num.toFixed(1);

  if (/\.0$/.test(fixed)) {
    fixed = fixed.substring(0, fixed.length - 2);
  }

  return fixed;
}

export function humanSize(bytes: number, baseUnit?: number): HumanSize {
  let unitPos = baseUnit || 0;

  while (bytes >= 1024) {
    unitPos++;
    bytes /= 1024;
  }

  return {
    size: fixPoint(bytes),
    unit: UNITS[unitPos],
  };
}

export function sizeDisplay(bytes: number, baseUnit?: number): string {
  const human = humanSize(bytes, baseUnit);

  return `${human.size} ${human.unit}`;
}

// from newfrontend kommon/src/path-utils.ts
export class PathUtils {
  public static rename(path: string, newName: string): string {
    const pathParts = path.slice(1).split('/');
    pathParts[pathParts.length - 1] = newName;
    return `/${pathParts.join('/')}`;
  }

  public static join(path: string, name: string): string {
    return (
      path +
      (/\/$/.test(path) ? '' : '/') +
      (name[0] !== '/' ? name : name.slice(1))
    );
  }

  public static joinPaths(parentPath: string, path: string): string {
    parentPath = PathUtils.normalize(parentPath);
    path = PathUtils.normalize(path);

    if (path === '/') {
      return parentPath;
    }
    return parentPath + (/\/$/.test(parentPath) ? '' : '/') + path.slice(1);
  }

  public static baseName(path: string): string {
    return path.split('/').pop() || '';
  }

  public static parent(path: string): string {
    const pathParts = path.slice(1).split('/');
    pathParts.pop();
    return `/${pathParts.join('/')}`;
  }

  public static normalize(path: string): string {
    if (path === '' || path === '/') {
      return '/';
    }
    if (path[path.length - 1] === '/') {
      return path.slice(0, path.length - 1);
    }
    return path;
  }

  // /foo/bar => [/, /foo, /foo/bar]
  public static chain(path: string): string[] {
    return PathUtils.chainTo(path, '/');
  }

  // path=/prefix/foo/bar, root=/prefix => [/prefix, /prefix/foo, /prefix/foo/bar]
  public static chainTo(path: string, root: string): string[] {
    const chain = [];

    let currentPath = path;

    while (currentPath !== root) {
      chain.unshift(currentPath);
      currentPath = PathUtils.parent(currentPath);
    }

    chain.unshift(root);

    return chain;
  }

  public static extension(name: string): string | undefined {
    const parts = name.split('.');
    return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : undefined;
  }

  public static parentPath(path) {
    const pathParts = path.split('/');
    pathParts.pop();
    return `${pathParts.join('/')}`;
  }
}
